export const UserIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.932 9.76758C12.0509 9.82427 12.9408 10.7498 12.9408 11.8828V14H11.5297V11.8828C11.5297 11.5174 11.2517 11.2159 10.8959 11.1797L10.8236 11.1768H5.17615C4.78646 11.1769 4.47107 11.4931 4.47107 11.8828V14H3.05896V11.8828C3.05896 10.7134 4.00676 9.76483 5.17615 9.76465H10.8236L10.932 9.76758ZM8.00037 2C9.94941 2.00019 11.5296 3.58023 11.5297 5.5293C11.5297 7.47842 9.94945 9.0584 8.00037 9.05859C6.05113 9.05859 4.47107 7.47854 4.47107 5.5293C4.47113 3.58011 6.05116 2 8.00037 2ZM8.00037 3.41211C6.83086 3.41211 5.88226 4.35981 5.8822 5.5293C5.8822 6.69884 6.83082 7.64746 8.00037 7.64746C9.16975 7.64727 10.1176 6.69872 10.1176 5.5293C10.1175 4.35992 9.16971 3.4123 8.00037 3.41211Z" />
  </svg>
);
